import React from "react";
import numeral from "numeral";
import PropTypes from "prop-types";

const Currency = ({ number, symbol }) => (
  <span>
    {symbol}
    {numeral(number).format("0,0")}
  </span>
);

Currency.propTypes = {
  number: PropTypes.number.isRequired,
  symbol: PropTypes.string
};

Currency.defaultProps = {
  symbol: "£"
};

export default Currency;
